export default __webpack_public_path__ + "static/media/MarkerIconTransparentGreen.683f2e14.svg";